import { BeneficiarioContratoBeneficiario } from "../../interfaces/entities/BeneficiarioContratoBeneficiario";

export const setItemListContratosBeneficiario = (listContratosBeneficiario: Array<BeneficiarioContratoBeneficiario> | undefined): void => {
  const data = JSON.stringify(listContratosBeneficiario);
  sessionStorage.setItem('listContratosBeneficiario', data);
}

export const getItemListContratosBeneficiario = (): Array<BeneficiarioContratoBeneficiario> => {
  const listContratosBeneficiario = sessionStorage.getItem('listContratosBeneficiario');
  var data: Array<BeneficiarioContratoBeneficiario> = listContratosBeneficiario ? JSON.parse(listContratosBeneficiario) : [];
  return data;
}